<ng-container *transloco="let t; prefix: 'thematic.update'">
    <div class="flex flex-row items-center justify-between">
        <h2 mat-dialog-title class="text-xl">
            {{ 'thematic.edit' | transloco }}
        </h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon svgIcon="heroicons_solid:x-mark" />
        </button>
    </div>
    <mat-dialog-content>
        <form
            id="updateThematicForm"
            [formGroup]="thematicForm"
            (ngSubmit)="onSubmit()"
        >
            <div class="grid grid-cols-2 gap-2">
                <mat-form-field>
                    <mat-label>{{ 'name-fr-label' | transloco }}</mat-label>
                    <input matInput formControlName="nameFr" id="nameFr" />
                    <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="trans.toFr('name')"
                        matTooltip="{{ 'trans-fr-tooltip' | transloco }}"
                    >
                        <mat-icon svgIcon="translate" />
                    </button>
                    @if (thematicForm.get('nameFr')?.hasError('required')) {
                        <mat-error>
                            {{ 'name-fr-required' | transloco }}
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'name-en-label' | transloco }}</mat-label>
                    <input matInput formControlName="nameEn" id="nameEn" />
                    <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="trans.toEn('name')"
                        matTooltip="{{ 'trans-en-tooltip' | transloco }}"
                    >
                        <mat-icon svgIcon="translate" />
                    </button>
                    @if (thematicForm.get('nameEn')?.hasError('required')) {
                        <mat-error>
                            {{ 'name-en-required' | transloco }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="grid grid-cols-2 gap-2">
                <mat-form-field>
                    <mat-label>{{
                        'description-fr-label' | transloco
                    }}</mat-label>
                    <textarea
                        matInput
                        formControlName="descriptionFr"
                        id="descriptionFr"
                        rows="3"
                    ></textarea>
                    <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="trans.toFr('description')"
                        matTooltip="{{ 'trans-fr-tooltip' | transloco }}"
                    >
                        <mat-icon svgIcon="translate" />
                    </button>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{
                        'description-en-label' | transloco
                    }}</mat-label>
                    <textarea
                        matInput
                        formControlName="descriptionEn"
                        id="descriptionEn"
                        rows="3"
                    ></textarea>
                    <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="trans.toEn('description')"
                        matTooltip="{{ 'trans-en-tooltip' | transloco }}"
                    >
                        <mat-icon svgIcon="translate" />
                    </button>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
        <button
            type="button"
            mat-stroked-button
            (click)="onCancel()"
            class="me-2"
        >
            {{ 'cancel' | transloco }}
        </button>
        <button
            type="submit"
            form="updateThematicForm"
            mat-raised-button
            color="primary"
            [disabled]="thematicForm.invalid"
        >
            {{ t('update-button') }}
        </button>
    </mat-dialog-actions>
</ng-container>
